export const NavbarConfig = [
    {
        label: "Quests",
        items: [
            {
                label: "Quests",
                path: "/questdesigner/quest",
                permission: "QuestDesigner:Quest:View"
            },
            {
                label: "Characters",
                path: "/questdesigner/character",
                permission: "CharacterProfile:View"
            },
            {
                label: "Story Groups",
                path: "/questdesigner/group",
                permission: "QuestDesigner:StoryGroup:View"
            },
            {
                label: "Placeholders",
                path: "/questdesigner/placeholder",
                permission: "QuestDesigner:Placeholder:View"
            }
        ]
    },
    {
        label: "Website",
        items: [
            {
                label: "Announcements",
                path: "/website/announcement",
                permission: "Website:Announcement:View"
            },
            {
                label: "Page Text",
                path: "/website/pagetext",
                permission: "Website:Page:View"
            },
            {
                label: "Application Types",
                path: "/website/application/type",
                permission: "Website:Application:Type:View"
            },
            {
                label: "Application Responses",
                path: "/website/application/response",
                permission: "Website:Application:View"
            },
            {
                label: "Files",
                path: "/website/files",
                permission: "Website:File:View"
            },
            {
                label: "Carousel",
                path: "/website/carousel",
                permission: "Website:Carousel:View"
            },
            {
                label: "Core Images",
                path: "/website/image/core",
                permission: "Website:Image:Core:View"
            },
            {
                label: "Links",
                path: "/website/link",
                permission: "Website:Link:View"
            },
        ]
    },
    {
        label: "Logs",
        items: [
            {
                label: "Dashboard Journal",
                path: "/log/dashboard",
                permission: "Logs:Dashboard:View"
            },
            {
                label: "Chat Logs",
                path: "/log/chat",
                permission: "Logs:Chat:View"
            },
            {
                label: "Command Logs",
                path: "/log/command",
                permission: "Logs:Command:View"
            },
            {
                label: "Monitoring",
                path: "/monitoring",
                permission: "Monitoring:View"
            },
            {
                label: "XP",
                path: "/log/xp",
                permission: "Logs:XP:View"
            },
            {
                label: "Crash Reports",
                path: "/log/crash-reports",
                permission: "Logs:CrashReports:View"
            },
            {
                label: "Forge Logs",
                path: "/log/forge",
                permission: "Logs:Forge:View"
            },
        ]
    },
    {
        label: "Discord",
        items: [
            {
                label: "Settings",
                path: "/discord/settings",
                permission: "DiscordBot:Settings:View"
            },
            {
                label: "Servers",
                path: "/discord/server",
                permission: "DiscordBot:Servers:View"
            },
        ]
    },
    {
        label: "Economy",
        items: [
            {
                label: "Transactions",
                path: "/economy/transaction",
                permission: "Economy:Transactions:View",
            },
            {
                label: "Bank Accounts",
                path: "/economy/accounts",
                permission: "Economy:BankAccount:View",
            },
            {
                label: "Overview",
                path: "/economy/overview",
                permission: "Economy:Overview",
            },
            {
                label: "Values",
                path: "/economy/values",
                permission: "Economy:Values",
            },
        ]
    },
    {
        label: "Weather",
        items: [
            {
                label: "Forecast",
                path: "/weather/forecast",
                permission: "Weather:Forecast:View",
            },
            {
                label: "Configuration",
                path: "/weather/configuration",
                permission: "Weather:Config:View",
            },
        ]
    },
    {
        label: "University",
        items: [
            {
                label: "Degrees",
                path: "/university/degree",
                permission: "University:Degree:View",
            },
            {
                label: "Modules",
                path: "/university/module",
                permission: "University:Module:View",
            },
            {
                label: "Books",
                path: "/university/book",
                permission: "University:Book:View",
            },
            {
                label: "Houses",
                path: "/university/house",
                permission: "University:House:View",
            },
        ]
    },
    {
        label: "Attributes",
        items: [
            {
                label: "Horse",
                path: "/attribute/horse",
                permission: "Horse:Attributes:View"
            },
            {
                label: "Player",
                path: "/attribute/player",
                permission: "Player:Attributes:View",
            },
        ]
    },
    {
        label: "Horse Tack",
        permission: "Horse:Tack:View",
        items: [
            {
                label: "Bonnet",
                path: "/horse/tack/bonnet",
            },
            {
                label: "Boots",
                path: "/horse/tack/boots",
            },
            {
                label: "Bridle",
                path: "/horse/tack/bridle",
            },
            {
                label: "Cinch",
                path: "/horse/tack/cinch",
            },
            {
                label: "Girth",
                path: "/horse/tack/girth",
            },
            {
                label: "Halter",
                path: "/horse/tack/halter",
            },
            {
                label: "Pad",
                path: "/horse/tack/pad",
            },
            {
                label: "Half Pad",
                path: "/horse/tack/half-pad",
            },
            {
                label: "Shaped Pad",
                path: "/horse/tack/shaped-pad",
            },
            {
                label: "Rein",
                path: "/horse/tack/rein",
            },
            {
                label: "Saddle",
                path: "/horse/tack/saddle",
            },
            {
                label: "Wraps",
                path: "/horse/tack/wraps",
            },
        ]
    },
    {
        label: "Fast Travel",
        items: [
            {
                label: "Groups",
                path: "/fasttravel/group",
                permission: "FastTravel:Group:View",
            },
            {
                label: "Points",
                path: "/fasttravel/point",
                permission: "FastTravel:Point:Edit",
            },
        ]
    },
    {
        label: "Collectables",
        items: [
            {
                label: "Groups",
                path: "/collectable/group",
                permission: 'Collectable:Group:View',
            },
            {
                label: "Items",
                path: "/collectable/item",
                permission: 'Collectable:Item:View',
            },
        ]
    },
    {
        label: "Conformation",
        items: [
            {
                label: "Measurements",
                path: "/conformation/measurement",
                permission: 'Conformation:Measurement:View',
            },
        ]
    },
    {
        label: "Illnesses",
        items: [
            {
                label: "Symptoms",
                path: "/illnesssymptom",
                permission: "Illnesses:Symptom:View",
            },
            {
                label: "Illnesses",
                path: "/illness",
                permission: "Illnesses:Illness:View",
            },
        ]
    },
    {
        label: "Warnings",
        path: "/warning/warning",
        permission: 'Warnings:Warning:View'
    },
    {
        label: "Horse",
        items: [
            {
                label: "Operations",
                path: "/operation",
                permission: "Operation:View"
            },
            {
                label: "Horse Gaits",
                path: "/horsegait",
                permission: "Horse:Gait:View"
            },
            {
                label: "Horse Shoes",
                path: "/horseshoe",
                permission: "Horse:Shoe:View"
            },
            {
                label: "Horse Bits",
                path: "/horsebit",
                permission: "Horse:Bit:View"
            },
            {
                label: "Disciplines",
                path: "/discipline",
                permission: "Disciplines:View"
            },
            {
                label: "Nutrients",
                path: "/nutrient",
                permission: "Nutrients:View"
            },
            {
                label: "Medicine",
                path: "/medicine",
                permission: "Medicines:Medicine:View"
            },
            {
                label: "Medicine Overdose Groups",
                path: "/medicineoverdosegroup",
                permission: "MedicineOverdoseGroup:View"
            },
            {
                label: "Provisions",
                path: "/provision",
                permission: "Provision:View"
            },
            {
                label: "Supplements",
                path: "/supplement",
                permission: "Supplement:View"
            },
            {
                label: "Alleles",
                path: "/allele",
                permission: 'Alleles:View'
            },
            {
                label: "Blood Age Settings",
                path: "/blood/age",
                permission: 'Blood:AgeSettings:View'
            },
            {
                label: "Blood Types",
                path: "/blood/type",
                permission: 'Blood:Type:View'
            },
            {
                label: "Ages",
                path: "/agesetting",
                permission: "AgeSetting:View"
            },
            {
                label: "Breeds",
                path: "/breed/breed",
                permission: "Breeds:Breed:View",
            },
            {
                label: "Breed Groups",
                path: "/breed/group",
                permission: "Breeds:Group:View",
            },
            {
                label: "Coat Textures",
                path: "/coat",
                permission: "Coat:View",
            },
            {
                label: "Personalities",
                path: "/personality",
                permission: "Personality:View",
            },
            {
                label: "Search",
                path: "/horse",
                permission: "Horse:View"
            },
            {
                label: "Pregnancy",
                path: "/pregnancy",
                permission: "Pregnancy:View"
            },
        ]
    },
    {
        label: "NPCs",
        path: "/npc",
        permission: "NPCs:NPC:View"
    },
    {
        label: "Factions",
        path: "/faction",
        permission: "Faction:View"
    },
    {
        label: "Discover Location",
        path: "/discoverlocation",
        permission: "DiscoverLocation:View"
    },
    {
        label: "Leaderboards",
        path: "/leaderboard",
        permission: "Leaderboards:View"
    },
    {
        label: "Shops",
        path: "/shop",
        permission: 'Shop:View'
    },
    {
        label: "Jobs",
        path: "/job",
        permission: "Job:View"
    },
    {
        label: "Sales Barn",
        path: "/salesbarn",
        permission: "SalesBarn:View"
    },
    {
        label: "Game Announcements",
        path: "/gameannouncement",
        permission: "GameAnnouncement:View"
    },
    {
        label: "Bulletins",
        path: "/bulletin",
        permission: 'Bulletins:View'
    },
    {
        label: "Import",
        items: [
            {
                label: "Player Donator Ranks",
                path: "/player/import/donatorrank",
                permission: "Player:Import:DonatorRank",
            },
            {
                label: "Player Club Plus",
                path: "/player/import/clubplus",
                permission: "Player:Import:ClubPlus",
            },
            {
                label: "Player Donator",
                path: "/player/import/donator",
                permission: "Player:Import:Donator",
            },
            {
                label: "Player Join Date",
                path: "/player/import/join_date",
                permission: "Player:Import:JoinDate",
            },
            {
                label: "Player Chat Tags",
                path: "/player/import/chat_tag",
                permission: "Player:Import:ChatTag",
            },
            {
                label: "Player Tokens",
                path: "/player/import/tokens",
                permission: "Player:Import:Tokens",
            },
            {
                label: "Player Advanced Tokens",
                path: "/player/import/advanced",
                permission: "Player:Import:DonatorData",
            },
        ]
    },
    {
        label: "Player",
        items: [
            {
                label: "Reports",
                path: "/player/report",
                permission: "Player:Report:View",
            },
            {
                label: "IP Check",
                path: "/player/ipcheck",
                permission: "Player:IPCheck",
            },
            {
                label: "Feedback",
                path: "/player/feedback",
                permission: "Feedback:View",
            },
            {
                label: "Export",
                path: "/player/export",
                permission: "Feedback:View",
            },
            {
                label: "Search",
                path: "/player",
                permission: "Player:View",
            },
            {
                label: "Bans",
                path: "/bans",
                permission: "Bans:View",
            },
            {
                label: "Fines",
                path: "/player/fine",
                permission: "Fines:View",
            },
            {
                label: "Token Balances",
                path: "/player/token-balances",
                permission: "TokenBalances:View",
            },
            {
                label: "Referral Rewards",
                path: "/player/referral-reward",
                permission: "PlayerReferral:View",
            },
        ]
    },
    {
        label: "Setup",
        items: [
            {
                label: "Settings",
                path: "/settings",
                permission: "Settings:View"
            },
            {
                label: "Users",
                path: "/user",
                permission: "User:View"
            },
            {
                label: "Roles",
                path: "/dashboardrole",
                permission: "DashboardRole:View"
            },
            {
                label: "Feature Flags",
                path: "/featureflag",
                permission: "FeatureFlags:View"
            },
            {
                label: "I18n",
                path: "/i18n",
                permission: "I18n:View"
            },
            {
                label: "I18n Prefixes",
                path: "/i18n-prefix",
                permission: "I18n:Prefix:View"
            },
            {
                label: "Blocked Phrases",
                path: "/blockedphrase",
                permission: "BlockedPhrases:View"
            },
            {
                label: "Server Rules",
                path: "/serverrule",
                permission: "ServerRules:View"
            },
            {
                label: "Horse Registration Organizations",
                path: "/registrationorganization",
                permission: "Registration:Organization:View"
            },
            {
                label: "Join & Leave Messages",
                path: "/joinleavemessage",
                permission: "JoinLeaveMessage:View"
            },
            {
                label: "Plot Settings",
                path: "/plotglobalsettings",
                permission: "PlotSettings:View"
            },
            {
                label: "Spawn Points",
                path: "/spawnpoint",
                permission: 'Spawn:View'
            },
            {
                label: "Business Categories",
                path: "/business/category",
                permission: 'Businesses:Category:View'
            },
            {
                label: "Chat Tags",
                path: "/chattag",
                permission: 'ChatTag:View'
            },
            {
                label: "Stud Registries",
                path: "/studregistry",
                permission: 'StudRegistry:View'
            },
            {
                label: "Warning Reasons",
                path: "/warning/reason",
                permission: 'Warnings:Reasons:View'
            },
            {
                label: "Skills",
                path: "/skill",
                permission: 'Skill:View'
            },
            {
                label: "Admin Tasks",
                path: "/admin/tasks",
                permission: "AdminTasks:View",
            },
            {
                label: "Unscramble Words",
                path: "/unscramble",
                permission: "Unscramble:View",
            },
            {
                label: "Daily Join Rewards",
                path: "/dailyjoinreward",
                permission: "DailyJoinReward:View",
            },
            {
                label: "Name Generator",
                path: "/namegenerator",
                permission: "NameGenerator:View",
            },
            {
                label: "Player Ranks",
                path: "/playerrank",
                permission: "Rank:View",
            },
            {
                label: "Navigator",
                path: "/navigator",
                permission: "Navigator:View",
            },
            {
                label: "Tags",
                path: "/tag",
                permission: "Tag:View",
            },
            {
                label: "Preset Builds",
                path: "/preset-build/build",
                permission: "PresetBuild:Build:View",
            },
            {
                label: "Preset Build Orders",
                path: "/preset-build/order",
                permission: "PresetBuild:Order:View",
            },
            {
                label: "Floating Text",
                path: "/floating-text",
                permission: "FloatingText:View",
            },
            {
                label: "Builder Server",
                path: "/builder/server",
                permission: "Builder:Server:View",
            },
            {
                label: "Double XP",
                path: "/double-xp",
                permission: "DoubleXp:View",
            },
            {
                label: "Roadmap",
                path: "/roadmap",
                permission: "Roadmap:View",
            },
            {
                label: "Badges",
                path: "/badge",
                permission: "Badge:View",
            },
            {
                label: "Credits",
                path: "/credit",
                permission: "Credit:View"
            },
        ]
    },
];